export default "__VITE_ASSET__ByrXJfol__"